import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import FAQ from './components/FAQ';
import Packages from './components/Packages';
import MedicalPrompts from './components/MedicalPrompts';
import Login from './components/Auth/Login';
import { Products } from './pages/Products';
import { Success } from './pages/Success';
import Signup from './components/Auth/Signup';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/medical-prompts" element={<MedicalPrompts />} />
        <Route path="/products" element={<Products />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </Router>
  );
}

export default App;